import {
  API_BASE_URL_AWS,
  API_BASE_URL_AZURE,
  API_BASE_URL_HOSTER,
  API_BASE_URL_LOCAL,
  API_BASE_URL_REALIABLE,
  API_BASE_URL_SAUCY,
  API_BASE_URL_SMARTER_ASP,
} from "constants/ApiConstant";

const dev = {
  API_ENDPOINT_URL: `${API_BASE_URL_LOCAL}/api`,
};
const netlify = {
  API_ENDPOINT_URL: `${API_BASE_URL_SAUCY}/api`,
}
const prod = {
  API_ENDPOINT_URL: `${API_BASE_URL_REALIABLE}/api`,
  //API_ENDPOINT_URL: `${API_BASE_URL_REALIABLE}/api`,
};

const test = {
  API_ENDPOINT_URL: "/api",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      const staging = process.env.REACT_APP_NETLIFY;
      if (staging === "NetlifyMode") {
        return netlify;
      } else {
        return prod;
      }

    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
